module.exports = __webpack_public_path__ + "static/media/home-image-1.d2148c06.jpg";